import { CommonModule } from '@angular/common';
import { Component, Injector, Input, ViewChild } from '@angular/core';
import { LocalizationService, LocalizationModule } from '@abp/ng.core';
import {
  CellValueChangedEvent,
  ColDef,
  GetContextMenuItemsParams,
  MenuItemDef,
} from '@ag-grid-community/core';

import {
  CustomerPreparationDto,
  CustomerPreparationService,
  DocLineRole,
} from '@digiwall/goliath-documents/proxy';
import { VatType } from '@digiwall/goliath-core/proxy';
import { ObserverQueue } from '@digiwall/core';
import { DocType } from '../../../base-docs/detail/doc-type';
import { BaseThirdPartyDocLineEditor, LinesEditorComponent } from '../../../../components';

interface ChapterLine {
  lineRole: DocLineRole;
  [key: string]: any;
}

@Component({
  selector: 'document-customer-preparation-lines-grid',
  templateUrl: './customer-preparation-lines-editor.component.html',
  imports: [CommonModule, LinesEditorComponent, LocalizationModule],
  providers: [ObserverQueue],
})
export class CustomerPreparationLinesEditorComponent extends BaseThirdPartyDocLineEditor<CustomerPreparationDto> {
  protected onCellValueChanged(event: CellValueChangedEvent<any, any>): void | PromiseLike<void> {
    // Update the line in the document when a cell value changes
  }
  @ViewChild('lineGrid') lineGrid: LinesEditorComponent;

  protected articleLineRole: DocLineRole = DocLineRole.CustomerPreparationArticleLine;
  protected textLineRole: DocLineRole = DocLineRole.CustomerDocText;
  protected chapterLineRole: DocLineRole = DocLineRole.DocChapter;

  descriptionColSpan: Partial<Record<DocLineRole, number>> = {
    [this.articleLineRole]: 1,
    [this.textLineRole]: 10,
    [this.chapterLineRole]: 7,
  };

  @Input() set doc(value: CustomerPreparationDto) {
    this._document = value;
    this.setLanguageCode();
  }

  @Input() set readonly(value: boolean) {
    this._readonly = value;
  }

  protected override articleLookupFn = (term: string) =>
    this.articleService.getArticleSellableSelectionLookup(term);

  public columnDefs: Array<ColDef> = [];

  constructor(
    localizationService: LocalizationService,
    customerPreparationService: CustomerPreparationService,
    injector: Injector,
    updateQueue: ObserverQueue,
  ) {
    super(localizationService, customerPreparationService, injector, updateQueue);

    this.initColDefs();
  }

  private initColDefs(): void {
    this.columnDefs = super.colDefs();
    this.columnDefs.push(
      ...([
        this.colDef_Quantity,
        this.colDef_ArticleSalesUnitCode(DocType.Sales),
        this.colDef_UnitPrice,
        this.colDef_Discount,
        this.colDef_VatCode(VatType.Sales),
        this.colDef_TotalPrice,
        this.colDef_UnitWeight,
        this.getColdef_StockLocation(DocType.Sales, true),
      ] as Array<ColDef>),
    );
  }

  override isChapter: (line: { lineRole?: DocLineRole }) => boolean = (line): boolean =>
    line.lineRole === this.chapterLineRole;

  protected getContextMenuItems = (params: GetContextMenuItemsParams): (string | MenuItemDef)[] => {
    return this.contextMenuItems(params);
  };
}
